import { useState, useEffect } from "react";
import axios from "axios";

function truncateFileName(name, max = 10) {
  return name.length > max ? name.slice(0, max) + "..." : name;
}

const FileDownloadButton = ({
  file_id,
  label = "檔案下載",
  showFileName = false,
  fileApi = "/component/file",
  blobApi = "/utility/file/blob",
}) => {
  const [fileName, setFileName] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!file_id || !showFileName) return;
    let isCancelled = false;

    axios
      .get(fileApi, { params: { file_id } })
      .then((response) => {
        if (!isCancelled) {
          const data = response.data;
          setFileName(data.file_name ?? data.filename ?? data.name ?? "unknown_file");
        }
      })
      .catch(() => {
        if (!isCancelled) setError("無法取得檔案名稱");
      });

    return () => {
      isCancelled = true;
    };
  }, [file_id, fileApi, showFileName]);

  const handleClick = () => {
    if (downloading) return;
    setDownloading(true);
    setError(null);

    axios
      .get(blobApi, { params: { file_id }, responseType: "blob" })
      .then((response) => {
        const url = URL.createObjectURL(response.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName ?? file_id;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      })
      .catch(() => {
        setError("下載失敗");
        setTimeout(() => setError(null), 3000);
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  const displayLabel = error
    ? error
    : downloading
    ? "下載中…"
    : showFileName && !fileName
    ? "載入中…"
    : showFileName && fileName
    ? truncateFileName(fileName)
    : label;

  const isDisabled = downloading || (showFileName && !fileName);

  return (
    <button
      onClick={handleClick}
      disabled={isDisabled}
      title={fileName ?? `${file_id}`}
      style={{
        display: "inline-block",
        padding: "6px 14px",
        border: error
          ? "0.5px solid var(--color-border-danger)"
          : "0.5px solid var(--color-border-secondary)",
        borderRadius: "var(--border-radius-md)",
        background: error
          ? "var(--color-background-danger)"
          : "var(--color-background-primary)",
        color: error
          ? "var(--color-text-danger)"
          : "var(--color-text-primary)",
        fontSize: "13px",
        fontFamily: "var(--font-sans)",
        cursor: isDisabled ? "not-allowed" : "pointer",
        opacity: isDisabled ? 0.6 : 1,
        transition: "opacity 0.15s",
        whiteSpace: "nowrap",
      }}
    >
      {displayLabel}
    </button>
  );
};

export default FileDownloadButton;